import { Attachment } from 'src/nicheaim-infrastructure/application/adapters/out/repositories/fhir/resources';

export const imageFromAttachment = (attachment?: Attachment) =>
  `data:${attachment?.contentType};base64,${attachment?.data}`;
